import { Autocomplete, Button, Grid, Stack, TextField } from '@mui/material';
import styles from './styles.module.css'
import AddIcon from '@mui/icons-material/Add';
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import { useEffect, useState } from 'react';
import { buscarComboPorCodigo } from '../../../services/auth.service';
import CircularProgress from '@mui/material/CircularProgress';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { adicionarVinculosWorkflow, substituirVinculosWorkflow } from '../../../services/api-planejamento-tributario.service';
import MensagemErro from '../../../components/MensagemErro';


const iconPerson = `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="14" width="14" viewBox="2 2 20 20"><path fill="${encodeURIComponent(
    '#fff',
)}" d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z"/></svg>')`

const iconGroup = `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="15" width="15" viewBox="2 2 20 20"><path fill="${encodeURIComponent(
    '#fff',
)}"  d="M12 12.75C13.63 12.75 15.07 13.14 16.24 13.65C17.32 14.13 18 15.21 18 16.38V18H6V16.39C6 15.21 6.68 14.13 7.76 13.66C8.93 13.14 10.37 12.75 12 12.75ZM4 13C5.1 13 6 12.1 6 11C6 9.9 5.1 9 4 9C2.9 9 2 9.9 2 11C2 12.1 2.9 13 4 13ZM5.13 14.1C4.76 14.04 4.39 14 4 14C3.01 14 2.07 14.21 1.22 14.58C0.48 14.9 0 15.62 0 16.43V18H4.5V16.39C4.5 15.56 4.73 14.78 5.13 14.1ZM20 13C21.1 13 22 12.1 22 11C22 9.9 21.1 9 20 9C18.9 9 18 9.9 18 11C18 12.1 18.9 13 20 13ZM24 16.43C24 15.62 23.52 14.9 22.78 14.58C21.93 14.21 20.99 14 20 14C19.61 14 19.24 14.04 18.87 14.1C19.27 14.78 19.5 15.56 19.5 16.39V18H24V16.43ZM12 6C13.66 6 15 7.34 15 9C15 10.66 13.66 12 12 12C10.34 12 9 10.66 9 9C9 7.34 10.34 6 12 6Z"/></svg>')`

const SwitchWorkflow = styled(Switch)(() => ({
    width: 70,
    height: 35,
    padding: 0,
    display: 'flex',
    '& .MuiSwitch-switchBase': {
        padding: 2,
        margin: 0,
        transform: 'translateX(0px)',
        '&.Mui-checked': {
            transform: 'translateX(35px)',
            color: '#fff',
            '& .MuiSwitch-thumb:before': {
                content: "''",
                position: 'absolute',
                width: '100%',
                height: '100%',
                left: 0,
                top: 0,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundImage: iconGroup,
            },
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: 'rgba(64, 196, 255, 0.38)',
            },
        },
    },

    '& .MuiSwitch-thumb': {
        boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
        width: 30,
        height: 30,
        borderRadius: 20,
        position: 'relative',
        backgroundColor: 'rgba(24, 49, 110, 1)',
        '&::before': {
            content: "''",
            position: 'absolute',
            width: '100%',
            height: '100%',
            left: 0,
            top: 0,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundImage: iconPerson,
        },
    },
    '& .MuiSwitch-track': {
        borderRadius: 35 / 2,
        opacity: 1,
        backgroundColor: 'rgba(64, 196, 255, 0.38)',
        boxShadow: 'inset 0px 0px 5px rgba(0, 0, 0, 0.5)',
        boxSizing: 'border-box',
    },
}));


const SecaoAdicionar = ({ itens, setItens, selectedDelete, onClose, idWkflProcesso }) => {
    const [switchSelected, setSwitchSelected] = useState(true)
    const [options, setOptions] = useState([])
    const [loading, setLoading] = useState(true)
    const [itemSelecionado, setItemSelecionado] = useState(null)
    const [openSnackbarErro, setOpenSnackbarErro] = useState(false);
    const [msg, setMsg] = useState('')


    useEffect(() => {
        setItemSelecionado(null)
        const fetchUsuario = async () => {
            try {
                setLoading(true)
                const response = await buscarComboPorCodigo('USUARIOWORKFLOW')
                const usuarios = response.detalhes.itensCombo.map(item => {
                    const split = item.split('/|/');
                    return { id: split[0], nome: split[1], tipo: 'USUARIO' }
                })
                setOptions(usuarios)
            } catch (error) {
                setMsg(error.response.data.mensagem)
                setOpenSnackbarErro(true)
            } finally {
                setLoading(false)
            }
        }

        const fetchGrupoUsuarios = async () => {
            try {
                setLoading(true)
                const response = await buscarComboPorCodigo('GRUPOUSUARIOWORKFLOW')
                const grupos = response.detalhes.itensCombo.map(item => {
                    const split = item.split('/|/');
                    return { id: split[0], nome: split[1], tipo: 'GRUPO_USUARIO' }
                })
                setOptions(grupos)

            } catch (error) {
                setMsg(error.response.data.mensagem)
                setOpenSnackbarErro(true)
            } finally {
                setLoading(false)
            }

        }

        switchSelected ? fetchGrupoUsuarios() : fetchUsuario()
    }, [switchSelected])

    const handleAdd = async () => {
        try {
            const lista = [...itens]
            if (selectedDelete) {
                const bodySub = {
                    idWkflProcesso,
                    ordem: selectedDelete.index + 1,
                    usuarioAntigo: {
                        idUsuario: selectedDelete.tipo === 'USUARIO' ? selectedDelete.id : null,
                        idGrupoUsuario: selectedDelete.tipo === 'GRUPO_USUARIO' ? selectedDelete.id : null,
                    },
                    usuarioNovo: {
                        idUsuario: itemSelecionado.tipo === 'USUARIO' ? itemSelecionado.id : null,
                        idGrupoUsuario: itemSelecionado.tipo === 'GRUPO_USUARIO' ? itemSelecionado.id : null,
                    }
                }
                await substituirVinculosWorkflow(bodySub)

                lista.splice(selectedDelete.index, 1, itemSelecionado)
            } else {
                const bodyAdd = {
                    idUsuario: itemSelecionado.tipo === 'USUARIO' ? itemSelecionado.id : null,
                    idGrupoUsuario: itemSelecionado.tipo === 'GRUPO_USUARIO' ? itemSelecionado.id : null,
                    ordem: itens.length + 1,
                    idWkflProcesso
                }
                await adicionarVinculosWorkflow(bodyAdd)
                lista.push(itemSelecionado)
            }
            setItens(lista)
            setItemSelecionado(null)
            onClose && onClose()
        } catch (error) {
            setMsg(error.response.data.mensagem)
            setOpenSnackbarErro(true)
        }
    }

    const handleChangeAutoComplete = (_, value) => {
        setItemSelecionado(value)
    }

    const handleCloseSnackbarErro = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenSnackbarErro(false);
    };

    return (
        <>
            <Grid container className={styles.gridContainer}>
                <Grid item lg={6} md={6} sm={12}>

                    <Stack direction="row" spacing={1} alignItems="center">
                        <span className={!switchSelected ? styles.selected : styles.notSelected}>Usuário</span>
                        <SwitchWorkflow
                            defaultChecked
                            value={switchSelected}
                            onChange={(e) => setSwitchSelected(e.target.checked)}
                        />
                        <span className={switchSelected ? styles.selected : styles.notSelected}>Grupo de Usuários</span>
                    </Stack>
                </Grid>
                <Grid item lg={4} md={4} sm={8}>
                    <Autocomplete
                        options={options}
                        fullWidth
                        size="small"
                        value={itemSelecionado}
                        loading={loading}
                        onChange={handleChangeAutoComplete}
                        getOptionLabel={option => option.nome}
                        isOptionEqualToValue={(option, value) => option.nome === value.nome}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={switchSelected ? 'Grupo de Usuários' : 'Usuário'}
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <>
                                            {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                            {params.InputProps.endAdornment}
                                        </>
                                    ),
                                }}
                            />
                        )}
                    />
                </Grid>
                <Grid item lg={2} md={2} sm={4}>
                    <Button
                        className={itemSelecionado ? styles.btnAdd : styles.btnAdd_disabled}
                        startIcon={selectedDelete ? <AutorenewIcon /> : <AddIcon />}
                        variant="outlined"
                        onClick={handleAdd}
                        disabled={!itemSelecionado}
                    >
                        {selectedDelete ? 'Substituir' : 'Adicionar'}
                    </Button>
                </Grid>
            </Grid>
            <MensagemErro
                open={openSnackbarErro}
                handleClose={handleCloseSnackbarErro}
                msg={msg}
            />
        </>
    )
}

export default SecaoAdicionar